// @ts-nocheck
import { Table } from "@shared/antd/table";
import { Icon } from "@shared/antd/icon";
import React from "react";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { DataInstanceStore } from "@cuba-platform/react";
import Button, { ButtonType } from "../../../components/Button/Button";
import { columnsTable, IParticipant, scrollTable } from "./constant";
import { observer } from "mobx-react";
import { ConcourseRequest } from "../../../../cuba/entities/base/tsadv_ConcourseRequest";
import { getUsersById } from "../api/getParticipants";
import { partipantsTableProps } from "../participantsList";

type State = {
  signal: boolean;
  loading: boolean;
}
type Props = {
  showModal?: () => void;
  selectedParticipants?: IParticipant[];
  deleteSelectedParticipants?: () => void;
  deleteSelectedParticipant?: (id: string) => void;
  status?: boolean;
  users?: DataInstanceStore<ConcourseRequest>;
  select?: any;
  table: partipantsTableProps;
  ifButtons?: boolean;
}

@observer
class ParticipantsTable extends React.Component<WrappedComponentProps & Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      signal: false,
      loading: false,
    };
  }


  loadingParticipantsInfo = async (id: string, createTs: string) => {
    const res = await getUsersById({
      personGroupId: id || "1",
      lang: this.props.table.lang,
      membersCreateTs: createTs,
    });
    return res[0];
  };

  checkParticipants = async () => {
    const { users } = this.props;
    this.setState({ loading: true });
    if (users && users.item && users.item.concourseRequestMembers) {
      const usersId = users.item.concourseRequestMembers.map(item => (
        {
          id: item.personGroup && item.personGroup.id,
          createTs: item.createTs,
        }
      ));
      const promises = usersId.map((item) => this.loadingParticipantsInfo(item.id, item.createTs));
      const usersInfo = await Promise.all(promises);
      const filteredArray: IParticipant[] = usersInfo.filter(item => (item !== undefined && (Array.isArray(item) ? item.length > 0 : true)));
      this.props.table.setSelectedParticipants(filteredArray);
    }
    this.setState({ loading: false });
    return [];
  };

  render() {
    const {
      showModal,
      status,
      deleteSelectedParticipant,
      selectedParticipants,
      deleteSelectedParticipants,
      ifButtons = true,
    } = this.props;
    const { loading } = this.state;
    const withi18n = (id: string) => {
      return this.props.intl.formatMessage({ id: id });
    };

    const buttons = [
      <Button style={{ margin: "12px" }} disabled={status} buttonType={ButtonType.PRIMARY} onClick={showModal}>
        <Icon type={"plus"} />
        {withi18n("cubaReact.dataTable.listEditor.addItem")}
      </Button>,
      <Button
        style={{ margin: "12px" }}
        disabled={status || selectedParticipants!.length === 0}
        buttonType={ButtonType.PRIMARY}
        onClick={deleteSelectedParticipants}
      >
        <Icon type={"delete"} />
        {withi18n("deleteAll")}
      </Button>,
    ];
    return (
      <div>
        {ifButtons && buttons}
        <Table dataSource={selectedParticipants}
               size="middle"
               bordered={false}
               scroll={scrollTable}
               loading={loading}
        >
          {
            columnsTable.map((item) => (
              <Table.Column
                title={withi18n(item.title)}
                dataIndex={item.dataIndex}
                key={item.key}

                render={(text, record: IParticipant) => (
                  item.title !== "dismissalRequest.staffUnitPosition"
                    ? text
                    : <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span style={{ display: "flex", alignItems: "center" }}>{text}</span>
                      {!status &&
                        <Button
                          style={{ margin: "12px" }}
                          buttonType={ButtonType.PRIMARY}
                          onClick={() => deleteSelectedParticipant!(record.person_group_id)}
                        >
                          <Icon type={"delete"} />
                        </Button>
                      }

                    </div>
                )}
              />
            ))
          }
        </Table>
      </div>

    );
  }

  componentDidUpdate(prevProps: Readonly<WrappedComponentProps & Props>, prevState: Readonly<State>, snapshot?: any) {
    const { users } = this.props;
    const { selectedParticipants } = this.props.table;
    if (users!.item !== undefined && !this.state.signal) {
      this.setState({ signal: true });
      this.checkParticipants();
    }
  }
}

export const ParticipantsTableComponent = injectIntl(ParticipantsTable);
